import { Text, Button } from '@clockout-dev/design-elements';
import styles from './styles/signInRedirect.module.scss';

export default function SigninRedirect({ loading, navigateLogin }) {
    return (
        <div className={styles.signInRedirectContainer}>
            <Text as="span" size="m">Already have an account?</Text>
            <Button
                type="button"
                variant="ghost"
                size="large"
                fontSize="m"
                color="secondary"
                loading={loading}
                onClick={() => navigateLogin()}
                className={styles.signInRedirectButton}
            >
                Sign in
            </Button>
        </div>
    );
}
